import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppServices } from '../../../services/appServices';
import { drill } from '../../../models/drill';
import { NgFor } from '@angular/common';
import { savePracticeTemplateDrillRequest } from '../../../models/savePracticeTemplateDrillRequest';
import { savePracticeTemplateRequest } from '../../../models/savePracticeTemplateRequest';

@Component({
  selector: 'app-create-template',
  standalone: true,
  imports: [FormsModule, NgFor],
  templateUrl: './create-template.component.html',
  styleUrl: './create-template.component.css'
})
export class CreateTemplateComponent implements OnInit{

  constructor(private appServices:AppServices) {}
  
  ngOnInit(): void {
    this.searchDrills();
  }

  @Output() saved = new EventEmitter();
  template = {
    label: ''
  }

  selectedDrills:savePracticeTemplateDrillRequest[] = [];

  selectableDrills:selectableDrill[] = [];
  get unselectedDrills() {
    return this.selectableDrills.filter(d => !d.isSelected);
  }

  async saveTempate() {
    let username = this.getUsername();
    if(!username) return;
    this.appServices.applicationService.showGlobalSpinner();
    let saveRequest:savePracticeTemplateRequest = {
      label: this.template.label,
      username: username,
      is_deleted: false,
      is_public: false,
      template_drills: this.selectedDrills
    }

    await this.appServices.templateService.saveTemplate(saveRequest);
    this.appServices.applicationService.hideGlobalSpinner();
    this.saved.emit();
  }

  async searchDrills() {
    let username = this.getUsername();
    if(!username) return;

    this.appServices.applicationService.showGlobalSpinner();
    let drills = await this.appServices.templateService.searchDrills(username);
    drills.forEach(d => this.selectableDrills.push({ isSelected: false, drill: d }));
    this.appServices.applicationService.hideGlobalSpinner();
  }

  selectDrill(drill: selectableDrill) {
    drill.isSelected = true;
    this.selectedDrills.push({
      drill: drill.drill,
      number_of_reps: 10
    });
  }

  getUsername():string|null {
    if(this.appServices.authenticationService.loggedInUser)
      return this.appServices.authenticationService.loggedInUser?.username;
    return null;
  }
}

interface selectableDrill {
  isSelected:boolean,
  drill:drill
}
